import type { CSSProperties } from "react";

/**
 * Identidade visual Apogeu.
 * Paleta fixa usada por todos os componentes (substitui o objeto `C` do protótipo).
 */
export const C = {
  ink: "#111111",
  gray: "#555555",
  light: "#8A8A8A",
  lime: "#A6D608",
  limeSoft: "#F3FADB",
  faint: "#EDEDED",
  bg: "#FAFAF8",
  white: "#FFFFFF",
  red: "#D64545",
  redSoft: "#FBEAEA",
  lightSoft: "#D9D9D9",
  overlay: "rgba(17, 17, 17, 0.45)",
} as const;

export const font = "'Space Grotesk','Segoe UI',system-ui,sans-serif";

/** Estilo padrão de campos (select, date, time) — borda/raio/fundo/fonte do design system. */
export const fieldStyle: CSSProperties = {
  fontFamily: font,
  fontSize: 12.5,
  color: C.ink,
  background: C.white,
  border: `1px solid ${C.faint}`,
  borderRadius: 10,
  padding: "9px 10px",
};

/** Estilo padrão dos tooltips do recharts. */
export const tooltipStyle: CSSProperties = {
  fontFamily: font,
  fontSize: 12,
  borderRadius: 10,
  border: `1px solid ${C.faint}`,
};
